import { Utils } from '../../Core';
import { partnerTokenApi as API } from '../../Apis';
import { mocksService } from './PartnerToken.mocks';
import dataFields from '../../Types/PartnerToken.json';

const invokeApiFunction = (stateRequestParameters: { partner: string }) =>
  API.call.post({
    type: stateRequestParameters.partner,
  });

export const { machine, Docs } = Utils.genericMachine({
  invokeApiFunction,
  definitionsAPI: API.definitions,
  mocksService,
  dataFields,
});
